<!--
 * @Description: 自定义设置详情弹窗
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/11/24 16:04
 -->
<template>
  <el-dialog
    :title="`${customLabel}计费依据自定义设置`"
    width="1000px"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="custom-rules-dialog billing-rules-style__wrapper"
  >
    <div v-for="(rule, idx) in customList" :key="idx" class="rule-item">
      <!--标题-->
      <div class="rule-item">
        <!--规则标题-->
        <h3 class="fee-rule-title rule-title">
          <span class="rule-title-idx">规则{{ idx + 1 }}</span>
        </h3>
      </div>
      <!--条件设置-->
      <div class="billing-rules-block__wrapper">
        <span class="block-label">条件</span>
        <div class="block-area">
          <div class="condition">
            <span class="condition-label">{{ rule.conditionTypeName }}</span>
          </div>
          <!--条件列表-->
          <div
            v-for="(condition, conditionIdx) in rule.conditions"
            :key="conditionIdx"
            class="condition"
          >
            <span class="condition-label">{{ condition.defineName }}</span>
            <span class="condition-operate">{{ condition.operatorName }}</span>
            <span class="condition-value">{{ condition.content }}</span>
          </div>
        </div>
      </div>
      <!--值-->
      <div class="billing-rules-block__wrapper">
        <span class="block-label">{{ customLabel }}等于</span>
        <div class="block-area">
          <div class="condition">
            <span class="condition-value">{{ rule.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "customDetail",

  data() {
    return {
      dialogVisible: false,
      customList: [],
      standard: ""
    };
  },

  computed: {
    // 自定义设置的类型
    customLabel() {
      switch (this.standard) {
        case "1": // 数量
          return "数量";
        case "2": // 重量
        case "5": // 吨公里
          return "重量";
        case "3": // 体积
        case "6": // 立方公里
          return "体积";
        default:
          return "";
      }
    }
  },

  methods: {
    show({ gist = [], standard = "" }) {
      this.customList = gist;
      this.standard = standard;
      this.dialogVisible = true;
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.customList = [];
      this.standard = "";
    }
  }
};
</script>

<style lang="scss">
@import "~e6-module-settle-accounts-center/assets/styles/billingRule.scss";
</style>
